import { render, staticRenderFns } from "./AffiliateReferralDetailPage.vue?vue&type=template&id=20fc4362&scoped=true&lang=pug&"
import script from "./AffiliateReferralDetailPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateReferralDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateReferralDetailPage.vue?vue&type=style&index=0&id=20fc4362&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc4362",
  null
  
)

export default component.exports